"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MessagesStream;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _MessagesStreamModule = _interopRequireDefault(require("./MessagesStream.module.scss"));

var _MessagesStream = _interopRequireDefault(require("./MessagesStream.i18n"));

var _inputElements = require("../../../../../../inputElements");

var _ChatMessage = _interopRequireDefault(require("../ChatMessage/ChatMessage"));

var _common = require("../../../../../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function MessagesStream(_ref) {
  var _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages,
      enabledChannels = _ref.enabledChannels,
      className = _ref.className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var messagesEndRef = (0, _react.useRef)(null);
  var scrollToBottom = (0, _react.useCallback)(function () {
    if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
      behavior: "auto"
    });
  }, []);
  var filteredMessages = (0, _react.useMemo)(function () {
    return enabledChannels ? messages.filter(function (message) {
      return enabledChannels === null || enabledChannels === void 0 ? void 0 : enabledChannels.includes(message.channel);
    }) : messages;
  }, [enabledChannels, messages]);
  var sortedFilteredMessages = (0, _react.useMemo)(function () {
    return filteredMessages.slice().sort(function (a, b) {
      return a.sentAt.getTime() - b.sentAt.getTime();
    });
  }, [filteredMessages]);
  var renderMessages = (0, _react.useCallback)(function () {
    setTimeout(function () {
      scrollToBottom();
    }, 50);
    return sortedFilteredMessages.map(function (message, i) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(_ChatMessage.default, {
          key: i,
          message: message,
          className: _MessagesStreamModule.default.message
        })
      );
    });
  }, [scrollToBottom, sortedFilteredMessages]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MessagesStreamModule.default.messagesStream, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MessagesStreamModule.default.messages
  }, renderMessages(), /*#__PURE__*/_react.default.createElement("div", {
    className: _MessagesStreamModule.default.inputRowSpacer
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: messagesEndRef,
    className: _MessagesStreamModule.default.messagesEnd
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _MessagesStreamModule.default.inputRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MessagesStreamModule.default.chatIcon
  }), /*#__PURE__*/_react.default.createElement(_common.BorderedBox, {
    type: "CHAT_INPUT",
    className: _MessagesStreamModule.default.inputBox
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    placeholder: formatMessage(_MessagesStream.default.inputPlaceholder)
  }))));
}